import DescriptionStrategy from './DescriptionStrategy'
import messageResource from '../../../../messageResource'

export default class WorkStatusesDescriptionStrategy extends DescriptionStrategy {
    constructor({ reportUrl = '' }) {
        super()
        this.params = { reportUrl }
    }

    getHeader() {
        return messageResource.getMessage('report.work_statuses.title')
    }

    getDescription() {
        const firstParagraph = messageResource.getEscapedMessage('dashboard.description.work_statuses.part1')
        const secondParagraph = messageResource.getEscapedMessage('dashboard.description.work_statuses.part2')
        return '<div>' +
               '  <div class="firstParagraph workStatusesDescriptionColor">' + firstParagraph + '</div>' +
               '  <div class="secondParagraph">' + secondParagraph + '</div>' +
               '</div>'
    }

    getGenerateCallback() {
        window.location.href = this.params.reportUrl
    }

    getDetailsCallback() {
        openUserGuidePage('reporting#report-work-statuses')
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/WorkStatusesDescriptionStrategy.js